export default {
  baseUrl: 'https://eco.pesttracksystem.com/api',
  // baseUrl: 'https://eco-dev.pesttracksystem.com/api',
  // baseUrl: 'http://ecolutionv1api.localhost',
  version: '1',
};



// WEBPACK FOOTER //
// ./src/libraries/config.js